import { QuestionMark, Whatshot, FormatListNumbered, CheckCircleOutlineOutlined, ScreenShareOutlined, ThumbsUpDown } from '@mui/icons-material';
import { Enumify } from 'enumify';
import TextActivityIcon from 'components/activity/SetupActivity/TextActivityIcon';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';

/**
 * Specifies what kind of stim-based session activity is being described.
 */
class ActivityType extends Enumify {
    static TextPrompt = new ActivityType({
        icon: TextActivityIcon
    });

    static Poll = new ActivityType({
        icon: CheckCircleOutlineOutlined
    });

    static Heatmap = new ActivityType({
        icon: Whatshot // Flame
    });

    static Ranking = new ActivityType({
        icon: FormatListNumbered
    });

    static ScreenShare = new ActivityType({
        icon: ScreenShareOutlined
    });

    static Batch = new ActivityType({
        icon: PlaylistAddCheckOutlinedIcon
    });

    static Agreement = new ActivityType({
        icon: ThumbsUpDown
    });

    static Unknown = new ActivityType({
        icon: QuestionMark
    });

    static _ = this.closeEnum();

    constructor (options) {
        super();
        this.icon = options.icon;
    }
}

export default ActivityType;
